import storage from '../utils/storage'

export default async () => {
  let jwt = storage.getJwt();
  if (jwt) return jwt
}
